<template>
  <v-container>
    <v-row>
      <!-- 氏名 -->
      <v-col cols="12" class="mb-4">
        <v-row>
          <v-col cols="12" md="3">
            氏名
            <span class="required">必須</span>
          </v-col>
          <v-col cols="12" md="9">
            <v-text-field
              v-model="data.name"
              :rules="rules.name"
              required
              outlined
              dense
              placeholder="全角（例：静岡太郎）"
              autocomplete="name"
              name="name"
              @input="onInput($event, 'name')"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <!-- ふりがな -->
      <v-col cols="12" class="mb-4">
        <v-row>
          <v-col cols="12" md="3">
            ふりがな
            <span class="required">必須</span>
          </v-col>
          <v-col cols="12" md="9">
            <v-text-field
              v-model="data.kana"
              :rules="rules.kana"
              required
              outlined
              dense
              placeholder="全角（例：しずおかたろう）"
              autocomplete="name"
              name="kana"
              @input="onInput($event, 'kana')"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <!-- 郵便番号 -->
      <v-col cols="12" class="mb-4">
        <v-row>
          <v-col cols="12" md="3">
            郵便番号
            <span class="required">必須</span>
          </v-col>
          <v-col cols="12" md="9">
            <v-text-field
              v-model="data.zipCode"
              :rules="rules.zipCode"
              required
              outlined
              dense
              placeholder="420-8602"
              autocomplete="postal-code"
              name="postal-code"
              @input="onInputZipCode"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <!-- 市区町村 -->
      <v-col cols="12" class="mb-4">
        <v-row>
          <v-col cols="12" md="3">
            市区町村
            <span class="required">必須</span>
          </v-col>
          <v-col cols="12" md="9">
            <v-text-field
              v-model="localData.city"
              :rules="rules.city"
              required
              outlined
              dense
              placeholder="静岡市葵区"
              autocomplete="city"
              name="city"
              @input="onInput($event, 'city')"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <!-- 番地 -->
      <v-col cols="12" class="mb-4">
        <v-row>
          <v-col cols="12" md="3">
            番地
            <span class="required">必須</span>
          </v-col>
          <v-col cols="12" md="9">
            <v-text-field
              v-model="localData.streetAddress"
              :rules="rules.streetAddress"
              required
              outlined
              dense
              placeholder="追手町5-1"
              autocomplete="streetAddress"
              name="streetAddress"
              @input="onInput($event, 'streetAddress')"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <!-- 建物・アパート名等 -->
      <v-col cols="12" class="mb-4">
        <v-row>
          <v-col cols="12" md="3"> 建物・アパート名等 </v-col>
          <v-col cols="12" md="9">
            <v-text-field
              v-model="localData.buildingName"
              outlined
              dense
              placeholder="ビル名・アパート名"
              hint="建物名まで入力してください。"
              persistent-hint
              autocomplete="buildingName"
              name="buildingName"
              @input="onInput($event, 'buildingName')"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <!-- TEL -->
      <v-col cols="12" class="mb-4">
        <v-row>
          <v-col cols="12" md="3">
            TEL
            <span class="required">必須</span>
          </v-col>
          <v-col cols="12" md="9">
            <v-text-field
              v-model="data.tel"
              :rules="rules.tel"
              required
              outlined
              dense
              hint="原則、当日ご連絡のつくお電話番号をご記入ください。"
              persistent-hint
              placeholder="090-0000-0000"
              autocomplete="tel"
              name="tel"
              type="tel"
              @input="onInput($event, 'tel')"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <!-- E-mail -->
      <v-col cols="12" class="mb-4">
        <v-row>
          <v-col cols="12" md="3">
            E-mail
            <span class="required">必須</span>
          </v-col>
          <v-col cols="12" md="9">
            <v-text-field
              v-model="data.email"
              :rules="rules.email"
              required
              outlined
              dense
              placeholder="example@mail.com"
              autocomplete="email"
              name="email"
              type="email"
              @input="onInput($event, 'email')"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import { validationRule } from '@api/constants';
import AddressSearcher from '@web/modules/address-searcher';
import Vue, { PropType } from 'vue';
import { mapActions, mapState } from '@web-e/store/cart';
import { CartBook } from '@web-t/store/cart';

export default Vue.extend({
  name: 'CartBookEdit',

  props: {
    value: {
      type: Object as PropType<CartBook>,
      default: undefined,
    },
  },

  data() {
    return {
      localData: {
        city: '',
        streetAddress: '',
        buildingName: '',
      },
    };
  },

  computed: {
    data: {
      get(): CartBook {
        return this.book || ({} as CartBook);
      },
      set(value: CartBook): void {
        this.setBook(value);
      },
    },

    rules() {
      return validationRule.items;
    },

    ...mapState(['book']),
  },

  mounted() {
    if (this.data.address) {
      const address = this.data.address;
      const addressParts = address.split(' ').map((part) => part.trim());
      if (addressParts.length >= 3) {
        this.localData.city = addressParts[0];
        this.localData.streetAddress = addressParts[1];
        this.localData.buildingName = addressParts.slice(2).join(' ');
      } else if (addressParts.length === 2) {
        this.localData.city = addressParts[0];
        this.localData.streetAddress = addressParts[1];
      } else if (addressParts.length === 1) {
        this.localData.streetAddress = addressParts[0];
      }

      this.updateFullAddress();
    }
  },

  methods: {
    onInput(value: string, name: string) {
      this.data = {
        ...this.data,
        [name]: value,
      };
      this.updateFullAddress();
    },

    updateFullAddress() {
      const fullAddress = [
        this.localData.city,
        this.localData.streetAddress,
        this.localData.buildingName,
      ]
        .filter((part) => part)
        .join(' ');
      this.data.address = fullAddress;
    },

    /**
     * 住所検索
     */
    async onInputZipCode(value: string) {
      if (!AddressSearcher.isZipCodeFormat(value)) {
        this.onInput(value, 'zipCode');
        return;
      }
      const result = await AddressSearcher.fetchAPI(value);
      if (!result) {
        this.onInput(value, 'zipCode');
        return;
      }
      const { address1, address2, address3 } = result;
      this.localData.city = `${address1}${address2}${address3}`;
      this.localData.streetAddress = ``;
      this.updateFullAddress();
    },

    ...mapActions(['setBook']),
  },
});
</script>
